/** Normalize API/user-detail status strings for lookup (case- and spacing-insensitive). */
const normalizeUserActivityStatusKey = (status) => {
	if (status == null || status === '') return '';
	return String(status)
		.trim()
		.replace(/\s+/g, ' ')
		.replace(/([a-z])([A-Z])/g, '$1 $2')
		.toLowerCase();
};

/**
 * Maps last-activity status → display label + badge-soft-* class (with variant="primary").
 * Keys are lowercase normalized; add aliases for API variants as needed.
 */
const USER_ACTIVITY_STATUS_BADGE_MAP = {
	error: { label: 'Error', className: 'badge-soft-danger' },
	failed: { label: 'Failed', className: 'badge-soft-danger' },
	pending: { label: 'Pending', className: 'badge-soft-secondary' },
	scheduled: { label: 'Scheduled', className: 'badge-soft-secondary' },
	completed: { label: 'Completed', className: 'badge-soft-success' },
	'email sent': { label: 'Email Sent', className: 'badge-soft-primary' },
	'sms sent': { label: 'SMS Sent', className: 'badge-soft-primary' },
	'message sent': { label: 'Message Sent', className: 'badge-soft-primary' },
	'call initiated': { label: 'Call Initiated', className: 'badge-soft-primary' },
	'email opened': { label: 'Email Opened', className: 'badge-soft-success' },
	'call picked': { label: 'Call Picked', className: 'badge-soft-success' },
	'call received': { label: 'Call Received', className: 'badge-soft-success' },
	'link clicked': { label: 'Link Clicked', className: 'badge-soft-warning' },
	'qrcode scanned': { label: 'QR Code Scanned', className: 'badge-soft-warning' },
	'qr code scanned': { label: 'QR Code Scanned', className: 'badge-soft-warning' },
	'data submitted': { label: 'Data Submitted', className: 'badge-soft-danger' },
	replied: { label: 'Replied', className: 'badge-soft-success' },
	'email reported': { label: 'Email Reported', className: 'badge-soft-success' },
	'system hacked': { label: 'System Hacked', className: 'badge-soft-danger' },
	'system hacks': { label: 'System Hacks', className: 'badge-soft-danger' },
	'attachment opened': { label: 'Attachment Opened', className: 'badge-soft-warning' },
	bounced: { label: 'Bounced', className: 'badge-soft-danger' },
	unsubscribed: { label: 'Unsubscribed', className: 'badge-soft-secondary' },
};

export const getUserActivityStatusBadgeProps = (status) => {
	const key = normalizeUserActivityStatusKey(status);
	if (!key) return { label: '—', className: 'badge-soft-secondary' };
	const cfg = USER_ACTIVITY_STATUS_BADGE_MAP[key];
	if (cfg) return { label: cfg.label, className: cfg.className };
	return { label: String(status).trim(), className: 'badge-soft-primary' };
};
